import React from "react";
import {Divider, Grid, List, ListItem, ListItemIcon, ListItemText} from "@mui/material";
import {FiberManualRecord, Today} from "@mui/icons-material";
import EnhancedIconButton from "./EnhancedIconButton";

function EnhancedAgenda(props) {
    const { searchResults, handleEventClick, isAgendaView, goToDate } = props;

    const handleClick = (event) => {
        handleEventClick({ event: event });
    };

    function getVisibility()
    {
        var display = 'none';
        if (isAgendaView) {
            display = 'inline';
        }

        return  {display: display}
    }

    return (
        <>
            <List sx={getVisibility}>
                {searchResults.map((event) => (
                    <React.Fragment key={event.id}>
                        <ListItem>
                            <ListItemIcon>
                                <FiberManualRecord style={{ color: event.backgroundColor }} />
                            </ListItemIcon>
                            <ListItemText primary={event.title} secondary={`${event.dateTimeText}`} onClick={() => handleClick(event)} />
                            <Grid>
                                <EnhancedIconButton
                                    authority="calendar.view"
                                    tooltip="Přejít na datum"
                                    size="medium"
                                    Icon={Today}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        goToDate(event.start);
                                    }}
                                    sx={goToDate === undefined ? 'display: none' : 'display: inline'}
                                />
                            </Grid>
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                ))}
            </List>
        </>
    );
}

export default EnhancedAgenda;
